import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getExpireDate, getCurrentUser} from '../../functions/utils'; 
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoaderComponent from '../utilities/LoaderComponent';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);
const JaarrekeningComponent = () => {
  const [isLoading, setIsLoading] = useState(false);  
  const [fvaiEmail, setFvaiEmail] = useState(false);  

  useEffect(() =>{
    init();
  },[]);

  // Handles the initial exact online setup
  async function init(){ 
    setIsLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    setFvaiEmail(queryParams.get('email'));
    console.log(queryParams.get('email'));
    clearQueryParams(['email']);
    redirectToJaarrekening(queryParams.get('email'), 'test', 'testtest');
    // window.location.href = 'http://localhost:3000/auth/jaarrekening?email=' + queryParams.get('email');
  }
 
  function redirectToJaarrekening(email, name, username) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://localhost:3000/api/auth/jaarrekening'; // use your factview-ai base URL in prod
    form.target = '_top';

    const fields = { email, name, username, shared_secret: "SHARED_SECRET" };
    for (const [key, value] of Object.entries(fields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value ?? '';
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  }

  return (
    <div className="jaarrekening-container">
        <div className="body-loader"><div className="loader"></div></div>
    </div>
  );
}

export default JaarrekeningComponent;
